import { useEffect } from 'react';
import Script from 'next/script';
import styles from './reviews.module.scss';

const Reviews = ({ SKU, locale }) => {
  let lang = locale;
  if (locale === 'se') {
    lang = 'sv-SE';
  } else if (locale === 'de') {
    lang = 'de-DE';
  } else if (locale === 'fr') {
    lang = 'fr-FR';
  } else if (locale === 'nl') {
    lang = 'nl-NL';
  } else if (locale === 'es') {
    lang = 'es-ES';
  } else if (locale === 'nl-be') {
    lang = 'nl-BE';
  } else if (locale === 'fr-be') {
    lang = 'fr-BE';
  } else if (locale === 'fr-fr') {
    lang = 'fr-FR';
  } else if (locale === 'dk') {
    lang = 'da-DK';
  } else if (locale === 'ni') {
    lang = 'en-NI';
  } else if (locale === 'ie') {
    lang = 'en-IE';
  } else if (locale === 'si') {
    lang = 'sl-SI';
  } else if (locale === 'ba') {
    lang = 'bs-BA';
  } else if (locale === 'at') {
    lang = 'de-AT';
  } else if (locale === 'na') {
    lang = 'en-GB';
  } else if (locale === 'no') {
    lang = 'no-NO';
  } else if (locale === 'hr') {
    lang = 'hr-HR';
  } else if (locale === 'sr') {
    lang = 'sr-RS';
  } else if (locale === 'ro') {
    lang = 'ro-RO';
  } else {
    lang = 'en-GB';
  }

  const emptyComment = {
    nl: 'Deze reviewer heeft geen opmerking achtergelaten',
    de: 'Der Kunde hat keinen Kommentar hinterlassen',
    fr: "L'auteur n'a laissé aucun commentaire",
    es: 'El cliente no ha dejado ningún comentario',
    sv: 'Recensenten lämnade ingen kommentar',
    da: 'Anmelderen efterlod ingen kommentar',
    no: 'Anmelderen la ikke igjen noen kommentar',
    sl: 'Ocenjevalec ni pustil komentarja',
    bs: 'Recenzent nije ostavio komentar',
    hr: 'Recenzent nije ostavio komentar',
    sr: 'Recenzent nije ostavio komentar',
    ro: 'Recenzentul nu a lăsat niciun comentariu',
  }[lang.slice(0, 2)];

  const settings = {
    // Your REVIEWS.io Store ID and widget type:
    store: 'keune.com',
    widget: 'polaris',
    // Content settings (store_review,product_review,third_party_review,questions). Choose what to display in this widget:
    options: {
      types: 'product_review',
      enable_sentiment_analysis: false,
      lang,
      // Possible layout options: bordered, large and reverse.
      layout: '',
      // How many reviews & questions to show per page?
      per_page: 5,
      store_review: {
        hide_if_no_results: true,
      },
      third_party_review: {
        hide_if_no_results: true,
      },
      // Product specific settings. Provide product SKU for which reviews should be displayed:
      product_review: {
        // Display product reviews - include multiple product SKUs seperated by Semi-Colons (Main Indentifer in your product catalog )
        sku: [SKU],
        hide_if_no_results: true,
      },
      // Questions settings:
      questions: {
        hide_if_no_results: true,
        enable_ask_question: true,
        enable_ask_question_button_style: false, // Show "be the first to ask a question" text as a button
        show_dates: true,
        // Display group questions by providing a grouping variable, new questions will be assigned to this group.
        grouping:
          '[Group questions by providing a grouping variable here or a specific product SKU]',
      },
      // Header settings:
      header: {
        enable_summary: true, // Show overall rating & review count
        enable_ratings: true,
        enable_attributes: false,
        enable_image_gallery: false, // Show photo & video gallery
        enable_percent_recommended: false, // Show what percentage of reviewers recommend it
        enable_write_review: false, // Show "Write Review" button
        enable_ask_question: false, // Show "Ask Question" button
        enable_sub_header: false, // Show subheader
        rating_decimal_places: 1,
        use_write_review_button: false, // Show "be the first to leave a review" text as a button
        enable_if_no_results: false, // Show header when there are no results
      },
      // AI summary settings
      // sentiment: {
      //   badge_text: 'Our Customers Say',
      // },
      // Filtering settings:
      filtering: {
        enable: true, // Show filtering options
        enable_text_search: true, // Show search field
        enable_sorting: true, // Show sorting options (most recent, most popular)
        enable_product_filter: false, // Show product options filter
        enable_media_filter: false, // Show reviews with images/video/media options
        enable_overall_rating_filter: true, // Show overall rating breakdown filter
        enable_language_filter: false, // Filter by review language
        enable_language_filter_language_change: false, // Update widget language based on language selected
        enable_ratings_filters: false, // Show product attributes filter
        enable_attributes_filters: false, // Show author attributes filter
        enable_expanded_filters: false, // Show filters as a section instead of dropdown
      },
      // Review settings:
      reviews: {
        enable_avatar: false, // Show author avatar
        enable_reviewer_name: true, // Show author name
        enable_reviewer_address: true, // Show author location
        reviewer_address_format: 'country', // Author location display format
        enable_verified_badge: true, // Show "Verified Customer" badge
        enable_subscriber_badge: true, // Show "Verified Subscriber" badge
        review_content_filter: 'undefined', // Filter content
        enable_reviewer_recommends: false, // Show "I recommend it" badge
        enable_attributes: true, // Show author attributes
        enable_product_name: false, // Show display product name
        enable_review_title: false, // Show review title
        enable_replies: false, // Show review replies
        enable_images: false, // Show display review photos
        enable_ratings: false, // Show product attributes (additional ratings)
        enable_share: false, // Show share buttons
        enable_helpful_vote: false, // Show "was this helpful?" section
        enable_helpful_display: false, // Show how many times times review upvoted
        enable_report: false, // Show report button
        enable_date: true, // Show when review was published
        enable_third_party_source: true, // Show third party source
        enable_duplicate_reviews: undefined, // Show multiple reviews from the same user
      },
    },
    // Translation settings
    translations: {
      'Verified Customer': 'Verified Customer',
      ...(emptyComment && { "Reviewer didn't leave any comments": emptyComment }),
    },
    // Style settings:
    styles: {
      // Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.
      '--base-font-size': '16px',
      // Button styles (shared between buttons):
      '--common-button-font-family': 'Acumin Pro',
      '--common-button-font-size': '16px',
      '--common-button-font-weight': '500',
      '--common-button-letter-spacing': '0',
      '--common-button-text-transform': 'none',
      '--common-button-vertical-padding': '10px',
      '--common-button-horizontal-padding': '20px',
      '--common-button-border-width': '2px',
      '--common-button-border-radius': '6px',
      // Primary button styles:
      '--primary-button-bg-color': '#000000',
      '--primary-button-border-color': '#000000',
      '--primary-button-text-color': '#ffffff',
      // Secondary button styles:
      '--secondary-button-bg-color': 'transparent',
      '--secondary-button-border-color': '#000000',
      '--secondary-button-text-color': '#000000',
      // Star styles:
      '--common-star-color': '#000000',
      '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
      '--medium-star-size': '22px',
      '--small-star-size': '18px',
      // Heading styles:
      '--heading-text-color': '#000000',
      '--heading-text-font-weight': '600',
      '--heading-text-font-family': 'Acumin Pro',
      '--heading-text-line-height': '1.4',
      '--heading-text-letter-spacing': '0px',
      '--heading-text-transform': 'none',
      // Body text styles:
      '--body-text-color': '#00000080',
      '--body-text-font-weight': '400',
      '--body-text-font-family': 'Acumin Pro',
      '--body-text-line-height': '1.4',
      '--body-text-letter-spacing': '0px',
      '--body-text-transform': 'inherit',
      // Input field styles:
      '--inputfield-text-font-family': 'Acumin Pro',
      '--input-text-font-size': '14px',
      '--inputfield-text-font-weight': '400',
      '--inputfield-text-color': '#000000',
      '--inputfield-border-color': 'rgba(0,0,0,0.2)',
      '--inputfield-background-color': 'transparent',
      '--inputfield-border-width': '3px',
      '--inputfield-border-radius': '6px',
      '--common-border-color': '#D6D6D6',
      '--common-border-width': '1px',
      '--common-sidebar-width': '200px',
      // Filters panel styles:
      '--filters-panel-bg-color': 'transparent',
      '--filters-panel-font-size': '16px',
      '--filters-panel-text-color': '16px',
      '--filters-panel-horizontal-padding': '0',
      '--filters-panel-vertical-padding': '0',
      // Slider indicator (for attributes) styles:
      '--slider-indicator-bg-color': 'rgba(0,0,0,0.1)',
      '--slider-indicator-button-color': '#0E1311',
      '--slider-indicator-width': '190px',
      // Badge styles:
      '--badge-icon-color': '#0000005C',
      '--badge-icon-font-size': 'Acumin Pro',
      '--badge-text-color': '#0000005C',
      '--badge-text-font-size': 'inherit',
      '--badge-text-letter-spacing': 'inherit',
      '--badge-text-transform': 'inherit',
      // Author styles:
      '--author-font-size': 'Acumin Pro',
      '--author-text-transform': 'inherit',
      // Author avatar styles:
      '--avatar-thumbnail-size': '60px',
      '--avatar-thumbnail-border-radius': '6px',
      '--avatar-thumbnail-text-color': '#0E1311',
      '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',
      // Product photo or review photo styles:
      '--photo-video-thumbnail-size': '80px',
      '--photo-video-thumbnail-border-radius': '6px',
      // Media (photo & video) slider styles:
      '--mediaslider-scroll-button-icon-color': '#0E1311',
      '--mediaslider-scroll-button-bg-color': 'rgba(255, 255, 255, 0.85)',
      '--mediaslider-overlay-text-color': '#ffffff',
      '--mediaslider-overlay-bg-color': 'rgba(0, 0, 0, 0.8))',
      '--mediaslider-item-size': '110px',
      // Pagination & tabs styles (normal):
      '--pagination-tab-text-color': '#000000',
      '--pagination-tab-text-transform': 'inherit',
      '--pagination-tab-text-letter-spacing': '0px',
      '--pagination-tab-text-font-size': '16px',
      '--pagination-tab-text-font-weight': '600',
      // Pagination & tabs styles (active):
      '--pagination-tab-active-text-color': '#000000',
      '--pagination-tab-active-text-font-weight': '600',
      '--pagination-tab-active-border-color': '#000000',
      '--pagination-tab-border-width': '3px',
      // AI summary styles
      '--sentiment-base-font-size': '15px',
      '--sentiment-panel-bg-color': '#EAEAEA',
      '--sentiment-panel-border-size': '0px',
      '--sentiment-panel-border-color': 'rgba(0, 0, 0, 0.1)',
      '--sentiment-panel-border-radius': '3px',
      '--sentiment-panel-shadow-size': '0px',
      '--sentiment-panel-shadow-color': 'rgba(0, 0, 0, 0.1)',
      '--sentiment-heading-text-color': '#0E1311',
      '--sentiment-heading-text-font-weight': '600',
      '--sentiment-heading-text-font-family': 'inherit',
      '--sentiment-heading-text-line-height': '1.4',
      '--sentiment-heading-text-letter-spacing': '0',
      '--sentiment-heading-text-transform': 'none',
      '--sentiment-body-text-color': '#6F6F6F',
      '--sentiment-body-text-font-weight': '400',
      '--sentiment-body-text-font-family': 'Acumin Pro',
      '--sentiment-body-text-line-height': '1.4',
      '--sentiment-body-text-letter-spacing': '0',
      '--sentiment-body-text-transform': 'none',
      '--sentiment-panel-vertical-padding': '25px',
      '--sentiment-panel-horizontal-padding': '25px',
      '--sentiment-header-text-color': '#FFFFFF',
      '--sentiment-header-text-font-size': '12px',
      '--sentiment-header-text-font-weight': 'Acumin Pro',
      '--sentiment-header-bg-color': '#000000',
      '--sentiment-header-border-radius': '3px',
      '--sentiment-header-shadow-size': '2px',
      '--sentiment-header-shadow-color': 'rgba(0, 0, 0, 0.1)',
      '--sentiment-header-vertical-padding': '7px',
      '--sentiment-header-horizontal-padding': '10px',
      '--sentiment-pagination-tab-text-font-size': '13px',
      '--sentiment-pagination-tab-text-font-weight': '500',
      '--sentiment-pagination-tab-text-color': '#000000',
      '--sentiment-pagination-tab-text-transform': 'none',
      '--sentiment-pagination-tab-text-letter-spacing': '0',
      '--sentiment-pagination-tab-active-text-color': '#000000',
      '--sentiment-pagination-tab-active-text-font-weight': '500',
      '--sentiment-pagination-tab-active-border-color': '#000000',
      '--sentiment-pagination-tab-border-width': '3px',
    },
  };

  useEffect(() => {
    if (SKU && typeof window !== 'undefined' && window.ReviewsWidget) {
      const container = document.getElementById('ReviewsWidget');
      if (container) {
        container.innerHTML = '';
      }

      try {
        window.ReviewsWidget('#ReviewsWidget', settings);
      } catch (e) {
        console.error('Error executing ReviewsWidget:', e);
      }
    }
  }, [SKU, locale]);

  // Reviews.io stores the reviewer country as an ISO code ("NL"). The widget shows that code without a change.
  useEffect(() => {
    if (typeof Intl.DisplayNames === 'undefined') return undefined;

    const regionNames = new Intl.DisplayNames([lang], { type: 'region' });

    const expand = () => {
      const els = document.querySelectorAll('#ReviewsWidget .c-meta__authorLocation');
      for (let i = 0; i < els.length; i += 1) {
        const code = els[i].textContent.trim();
        if (/^[A-Z]{2}$/.test(code)) {
          els[i].textContent = regionNames.of(code);
        }
      }
    };

    expand();
    const container = document.getElementById('ReviewsWidget');
    const observer = new MutationObserver(expand);
    if (container) observer.observe(container, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [lang]);

  // Strip the Product JSON-LD that the Polaris widget injects — we emit our own
  // ProductGroup schema in getNewSchema.js and don't want a duplicate Product block.
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const remove = () => document.getElementById('reviewsWidgetProductSnippets')?.remove();
    remove();
    const observer = new MutationObserver(remove);
    observer.observe(document.head, { childList: true, subtree: true });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  if (!SKU) return null;

  return (
    <div className={styles.container}>
      <div id="ReviewsWidget" />

      <Script
        type="text/javascript"
        strategy="afterInteractive"
        onLoad={() => {
          // Initial load
          if (typeof window !== 'undefined' && window.ReviewsWidget) {
            try {
              window.ReviewsWidget('#ReviewsWidget', settings);
            } catch (e) {
              console.error('Error executing ReviewsWidget:', e);
            }
          }
        }}
      >
        {`try{ReviewsWidget("#ReviewsWidget",${JSON.stringify(
          settings
        )});}catch(e){console.error('Error executing ReviewsWidget:', e);}`}
      </Script>
    </div>
  );
};

export default Reviews;
